import { useEffect, useState } from 'react';
import { useMutation } from '@apollo/client';
import { useLocation } from '@scentregroup/shared/next/compat/location';
import { MergeGuestCart } from '../../../apps/checkout/src/client/graphql/queries';
import { useCustomerCart } from './use-user';
const useMergedGuestCart = user => {
  var _user$customerCart, _user$customerCart2;
  const [customerCart, setCustomerCart] = useCustomerCart();
  const cartId = customerCart === null || customerCart === void 0 ? void 0 : customerCart.id;
  const location = useLocation();
  const {
    0: allowMergeGuestCart,
    1: setAllowMergeGuestCart
  } = useState(() => new URLSearchParams(location.search).has('allowMergeGuestCart'));
  const [mergeGuestCart] = useMutation(MergeGuestCart, {
    context: {
      version: 2
    },
    onCompleted(data) {
      if (data !== null && data !== void 0 && data.mergeGuestCart) {
        setCustomerCart({
          id: data.mergeGuestCart.customerCart.id,
          itemCount: data.mergeGuestCart.customerCart.itemCount.toString()
        });
      } else {
        setCustomerCart(null);
      }
      setAllowMergeGuestCart(false);
    }
  });
  const customerCartId = user === null || user === void 0 || (_user$customerCart = user.customerCart) === null || _user$customerCart === void 0 ? void 0 : _user$customerCart.id;
  const customerCartCount = user === null || user === void 0 || (_user$customerCart2 = user.customerCart) === null || _user$customerCart2 === void 0 ? void 0 : _user$customerCart2.itemCount.toString();
  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    setAllowMergeGuestCart(queryParams.has('allowMergeGuestCart'));
  }, [location.search]);
  useEffect(() => {
    // when a member log in with a previously registered cart
    if (allowMergeGuestCart && !cartId && customerCartId && customerCartCount) {
      setCustomerCart({
        id: customerCartId,
        itemCount: customerCartCount
      });
      setAllowMergeGuestCart(false);
    }
  }, [allowMergeGuestCart, customerCartId, customerCartCount, cartId, setCustomerCart]);
  useEffect(() => {
    // when a member log in with an existing cart but has no previously registered cart - register the an existing cart to this member
    if (allowMergeGuestCart && cartId && !customerCartId && user) {
      mergeGuestCart({
        variables: {
          input: {
            guestCartId: cartId
          }
        }
      });
    }
  }, [allowMergeGuestCart, user, cartId, customerCartId, mergeGuestCart]);
  useEffect(() => {
    // when a member log in with an existing cart and a previously registered cart
    if (allowMergeGuestCart && cartId && customerCartId && cartId !== customerCartId) {
      mergeGuestCart({
        variables: {
          input: {
            guestCartId: cartId,
            customerCartId
          }
        }
      });
    }
  }, [allowMergeGuestCart, cartId, customerCartId, mergeGuestCart]);
  return null;
};
export default useMergedGuestCart;